@for (section of sections; track section.name) {
  @if (quoteRequestForm !== undefined && selectedStateBond() !== null &&
  sectionHasQuestions(section.name, selectedStateBond())) {
  <form [formGroup]="quoteRequestForm" class="cipx-form-section">
    <fieldset>
      <legend class="cipx-form-section-title">{{ section.title }}</legend>

      <cipx-quote-request-intake-form-question-set
        [quoteRequestForm]="quoteRequestForm"
        [stateBond]="selectedStateBond()"
        [sectionName]="section.name"></cipx-quote-request-intake-form-question-set>

      @for (collectionSet of collectionSetsBySection()[section.name]; track collectionSet.question_set_code) {
        <cipx-quote-request-intake-form-question-collection
          [quoteRequestForm]="quoteRequestForm"
          [questionSet]="collectionSet"></cipx-quote-request-intake-form-question-collection>
      }
    </fieldset>
  </form>
  }
}
